import React, { useState } from 'react';
import { Shield, Lock, Cookie, FileText, Users, Accessibility, Mail, Scale, ChevronDown, ChevronUp } from 'lucide-react';

const policyData = [
  {
    id: 'confidentialite',
    icon: Lock,
    number: '1',
    title: 'Politique de confidentialité (Loi 25 — Québec)',
    subsections: [
      {
        id: '1.1',
        title: 'Engagement de Nexor Talents',
        content: 'Nexor Talents protège la confidentialité, l\u2019intégrité et la sécurité des renseignements personnels confiés dans le cadre de ses activités de recrutement, d\u2019évaluation et d\u2019accompagnement professionnel.\n\nNos pratiques respectent les lois applicables au Québec, incluant la Loi 25 sur la protection des renseignements personnels dans le secteur privé. Cette politique s\u2019applique à l\u2019ensemble des activités de Nexor Talents, qu\u2019elles soient menées en ligne ou hors ligne.'
      },
      {
        id: '1.2',
        title: 'Responsable de la protection des renseignements personnels',
        content: 'Responsable de la protection des renseignements personnels\nNexor Talents\nCourriel : cplante@nexortalents.com\n\nCette personne supervise la gouvernance, la conformité et le traitement des demandes d\u2019accès, de rectification ou de retrait. Elle veille également à la mise en place de politiques internes de protection et à la formation du personnel en matière de confidentialité.'
      },
      {
        id: '1.3',
        title: 'Renseignements collectés',
        content: 'Nous recueillons uniquement les renseignements nécessaires à nos activités. La collecte est effectuée de manière transparente et proportionnelle aux fins visées :',
        list: [
          'identité et coordonnées (nom, prénom, adresse courriel, téléphone);',
          'CV, parcours professionnel, compétences, diplômes et certifications;',
          'informations fournies lors d\u2019entretiens, formulaires ou échanges;',
          'données techniques (adresse IP, type de navigateur, cookies, données de navigation);',
          'références professionnelles fournies avec votre autorisation;',
          'préférences de communication et historique d\u2019interactions avec Nexor Talents.'
        ]
      },
      {
        id: '1.4',
        title: 'Finalités de l\u2019utilisation',
        content: 'Les renseignements sont utilisés exclusivement pour les fins suivantes :',
        list: [
          'analyser, évaluer et présenter des candidatures à des employeurs potentiels;',
          'proposer des opportunités professionnelles adaptées à votre profil;',
          'communiquer avec les candidats et les clients dans le cadre du processus de recrutement;',
          'optimiser nos services, nos outils et l\u2019expérience utilisateur de notre site;',
          'produire des statistiques anonymisées à des fins d\u2019amélioration continue;',
          'respecter nos obligations légales et réglementaires.'
        ]
      },
      {
        id: '1.5',
        title: 'Consentement',
        content: 'Le dépôt d\u2019une candidature ou l\u2019utilisation du site constitue un consentement éclairé à la collecte et à l\u2019utilisation de vos renseignements conformément à la présente politique.\n\nLe consentement peut être retiré en tout temps en communiquant avec notre responsable de la protection des renseignements personnels. Le retrait du consentement n\u2019affecte pas la légalité du traitement effectué avant celui-ci.'
      },
      {
        id: '1.6',
        title: 'Communication à des tiers',
        content: 'Les renseignements peuvent être partagés avec les parties suivantes, dans le respect strict de la confidentialité :',
        list: [
          'des employeurs clients dans le cadre d\u2019un processus de recrutement actif;',
          'des partenaires technologiques sécurisés (hébergement, outils de gestion);',
          'des fournisseurs de services professionnels (comptabilité, services juridiques);',
          'des autorités compétentes, lorsque requis par la loi.'
        ],
        afterList: 'Aucun renseignement n\u2019est vendu, loué ou monétisé à des fins commerciales. Tout partage est encadré par des ententes de confidentialité.'
      },
      {
        id: '1.7',
        title: 'Conservation et sécurité',
        content: 'Les renseignements sont conservés pour la durée nécessaire aux fins prévues ou conformément aux exigences légales applicables. À l\u2019expiration de cette période, les données sont détruites de manière sécurisée.\n\nNous appliquons des mesures de sécurité administratives, technologiques et physiques conformes aux meilleures pratiques de l\u2019industrie, incluant le chiffrement des données sensibles, la restriction des accès et la surveillance continue de nos systèmes.'
      },
      {
        id: '1.8',
        title: 'Droits des personnes concernées',
        content: 'Conformément à la Loi 25, vous disposez des droits suivants :',
        list: [
          'accéder à vos renseignements personnels détenus par Nexor Talents;',
          'demander la correction de renseignements inexacts ou incomplets;',
          'demander la suppression de vos données lorsque permis par la loi;',
          'obtenir des précisions sur l\u2019utilisation et la communication de vos données;',
          'déposer une plainte auprès de la Commission d\u2019accès à l\u2019information du Québec.'
        ],
        afterList: 'Pour exercer vos droits, communiquez avec notre responsable à cplante@nexortalents.com. Nous nous engageons à répondre dans un délai de 30 jours.'
      }
    ]
  },
  {
    id: 'cookies',
    icon: Cookie,
    number: '2',
    title: 'Politique de cookies',
    subsections: [
      {
        id: '2.1',
        title: 'Utilisation des cookies',
        content: 'Nexor Talents utilise des cookies et des technologies similaires pour assurer la performance, la sécurité et l\u2019optimisation de son site web. Un cookie est un petit fichier texte stocké sur votre appareil lorsque vous visitez notre site. Il permet de mémoriser vos préférences et d\u2019améliorer votre expérience de navigation.'
      },
      {
        id: '2.2',
        title: 'Types de cookies',
        content: 'Nous utilisons les catégories de cookies suivantes :',
        list: [
          'Essentiels : nécessaires au fonctionnement technique du site (authentification, sécurité, navigation de base). Ces cookies ne peuvent pas être désactivés.',
          'Fonctionnels : permettent de mémoriser vos préférences de langue, de navigation et de personnalisation.',
          'Statistiques : collectent des données anonymisées sur l\u2019utilisation du site afin d\u2019en améliorer la performance (ex. Google Analytics).',
          'Marketing : utilisés pour mesurer la performance de nos campagnes et afficher du contenu pertinent.'
        ]
      },
      {
        id: '2.3',
        title: 'Durée de conservation',
        content: 'Les cookies de session sont supprimés automatiquement à la fermeture de votre navigateur. Les cookies persistants sont conservés pour une durée maximale de 12 mois, après quoi ils expirent ou sont renouvelés selon vos préférences.'
      },
      {
        id: '2.4',
        title: 'Gestion des cookies',
        content: 'Vous pouvez à tout moment ajuster vos préférences de cookies dans les paramètres de votre navigateur. Vous avez la possibilité de bloquer ou de supprimer les cookies existants. Veuillez noter que la désactivation de certains cookies pourrait limiter certaines fonctionnalités du site ou affecter votre expérience de navigation.'
      }
    ]
  },
  {
    id: 'conditions',
    icon: FileText,
    number: '3',
    title: 'Conditions d\u2019utilisation du site',
    subsections: [
      {
        id: '3.1',
        title: 'Acceptation',
        content: 'En accédant au site web de Nexor Talents, vous reconnaissez avoir lu, compris et accepté les présentes conditions d\u2019utilisation. Si vous n\u2019acceptez pas ces conditions, veuillez ne pas utiliser le site.'
      },
      {
        id: '3.2',
        title: 'Utilisation permise',
        content: 'L\u2019utilisateur s\u2019engage à :',
        list: [
          'utiliser le site de manière légale, respectueuse et conforme à son objet;',
          'ne pas tenter de compromettre la sécurité, l\u2019intégrité ou la disponibilité du site;',
          'ne pas soumettre de contenu frauduleux, diffamatoire, discriminatoire ou non sollicité;',
          'ne pas utiliser de robots, scripts ou outils automatisés pour extraire des données du site;',
          'ne pas usurper l\u2019identité d\u2019une autre personne ou organisation.'
        ]
      },
      {
        id: '3.3',
        title: 'Propriété intellectuelle',
        content: 'L\u2019ensemble du contenu publié sur le site (textes, images, visuels, logos, identité de marque, mise en page) est la propriété exclusive de Nexor Talents et est protégé par les lois canadiennes et internationales sur le droit d\u2019auteur et la propriété intellectuelle.\n\nToute reproduction, distribution, modification ou utilisation non autorisée, en tout ou en partie, est strictement interdite sans le consentement écrit préalable de Nexor Talents.'
      },
      {
        id: '3.4',
        title: 'Limitation de responsabilité',
        content: 'Nexor Talents ne peut être tenue responsable des dommages directs ou indirects liés à l\u2019utilisation du site, à l\u2019indisponibilité temporaire du service, à des erreurs techniques ou à des pertes de données. Le site est fourni « tel quel », sans garantie d\u2019aucune sorte, expresse ou implicite.'
      },
      {
        id: '3.5',
        title: 'Liens externes',
        content: 'Le site peut contenir des liens vers des sites web tiers. Ces liens sont fournis à titre informatif uniquement. Nexor Talents n\u2019exerce aucun contrôle sur le contenu, les pratiques de confidentialité ou les politiques de ces sites et décline toute responsabilité à leur égard.'
      },
      {
        id: '3.6',
        title: 'Modifications des conditions',
        content: 'Nexor Talents se réserve le droit de modifier les présentes conditions à tout moment. Les modifications entrent en vigueur dès leur publication sur le site. L\u2019utilisation continue du site après la publication constitue une acceptation des nouvelles conditions.'
      }
    ]
  },
  {
    id: 'candidatures',
    icon: Users,
    number: '4',
    title: 'Politique de traitement des candidatures',
    subsections: [
      {
        id: '4.1',
        title: 'Objectif',
        content: 'Cette politique vise à assurer un traitement professionnel, équitable, transparent et confidentiel de l\u2019ensemble des candidatures reçues par Nexor Talents, que ce soit par le site web, par courriel ou lors d\u2019échanges directs.'
      },
      {
        id: '4.2',
        title: 'Collecte des informations',
        content: 'Les informations relatives aux candidats proviennent des sources suivantes :',
        list: [
          'CV et documents soumis via le site ou par courriel;',
          'formulaires de candidature en ligne;',
          'entretiens téléphoniques, vidéo ou en personne;',
          'échanges électroniques (courriels, messagerie);',
          'références professionnelles fournies avec l\u2019autorisation du candidat;',
          'profils professionnels publics (ex. LinkedIn), lorsque pertinent.'
        ]
      },
      {
        id: '4.3',
        title: 'Évaluation des candidatures',
        content: 'Chaque candidature est évaluée de manière objective et rigoureuse selon les critères suivants :',
        list: [
          'les compétences techniques et professionnelles;',
          'l\u2019expérience pertinente et le parcours du candidat;',
          'les exigences spécifiques du poste à pourvoir;',
          'les besoins et la culture de l\u2019employeur client;',
          'les aspirations et les valeurs du candidat.'
        ],
        afterList: 'Aucune discrimination fondée sur l\u2019origine, le sexe, l\u2019âge, la religion, l\u2019orientation sexuelle, le handicap ou tout autre motif prohibé n\u2019est tolérée. Nexor Talents s\u2019engage à promouvoir l\u2019équité, la diversité et l\u2019inclusion dans l\u2019ensemble de ses processus.'
      },
      {
        id: '4.4',
        title: 'Conservation',
        content: 'Les candidatures et les renseignements associés peuvent être conservés dans notre base de données pour une période raisonnable afin de faciliter le jumelage avec de futures opportunités, sauf demande contraire du candidat. Vous pouvez demander la suppression de votre dossier à tout moment en communiquant avec nous.'
      },
      {
        id: '4.5',
        title: 'Confidentialité',
        content: 'Les informations des candidats sont traitées avec la plus grande discrétion. Elles sont partagées uniquement avec les employeurs directement concernés par le processus de recrutement, et seulement après avoir obtenu le consentement explicite du candidat. Aucune candidature n\u2019est transmise sans approbation préalable.'
      },
      {
        id: '4.6',
        title: 'Communication avec les candidats',
        content: 'Nexor Talents s\u2019engage à maintenir une communication respectueuse et transparente avec chaque candidat tout au long du processus. Nous informons les candidats de l\u2019avancement de leur dossier et fournissons, dans la mesure du possible, une rétroaction constructive.'
      }
    ]
  },
  {
    id: 'accessibilite',
    icon: Accessibility,
    number: '5',
    title: 'Politique d\u2019accessibilité',
    subsections: [
      {
        id: '5.1',
        title: 'Engagement',
        content: 'Nexor Talents s\u2019engage à offrir un site web accessible à toutes les personnes, y compris celles vivant avec un handicap. Nous visons la conformité aux standards WCAG 2.1 niveau AA (Web Content Accessibility Guidelines) afin de garantir une expérience inclusive et équitable pour tous les utilisateurs.'
      },
      {
        id: '5.2',
        title: 'Mesures mises en place',
        content: 'Pour assurer l\u2019accessibilité de notre site, nous avons mis en place les mesures suivantes :',
        list: [
          'textes alternatifs descriptifs pour les images et éléments visuels;',
          'navigation complète au clavier pour les utilisateurs ne pouvant pas utiliser une souris;',
          'contrastes de couleurs adaptés pour une meilleure lisibilité;',
          'structure claire et hiérarchisée des contenus (titres, sous-titres, listes);',
          'formulaires accessibles avec des étiquettes explicites;',
          'compatibilité avec les technologies d\u2019assistance (lecteurs d\u2019écran).'
        ]
      },
      {
        id: '5.3',
        title: 'Amélioration continue',
        content: 'L\u2019accessibilité est un processus continu. Nous révisons régulièrement notre site pour identifier et corriger les obstacles potentiels. Nous nous engageons à intégrer les meilleures pratiques d\u2019accessibilité dans chaque mise à jour de notre plateforme.'
      },
      {
        id: '5.4',
        title: 'Demandes d\u2019adaptation',
        content: 'Si vous rencontrez des difficultés d\u2019accès ou si vous avez besoin d\u2019un accommodement particulier, n\u2019hésitez pas à nous contacter. Toute demande sera traitée avec diligence et bienveillance.\n\nContactez-nous à : cplante@nexortalents.com'
      }
    ]
  },
  {
    id: 'securite',
    icon: Shield,
    number: '6',
    title: 'Politique de sécurité de l\u2019information',
    subsections: [
      {
        id: '6.1',
        title: 'Engagement',
        content: 'Nexor Talents accorde la plus haute importance à la sécurité de l\u2019information. Nous protégeons les renseignements personnels et professionnels qui nous sont confiés contre l\u2019accès non autorisé, la perte, la divulgation, l\u2019altération ou la destruction, qu\u2019elle soit accidentelle ou malveillante.'
      },
      {
        id: '6.2',
        title: 'Mesures de sécurité',
        content: 'Nous mettons en oeuvre un ensemble de mesures de sécurité adaptées à la sensibilité des données traitées :',
        list: [
          'contrôle d\u2019accès strict basé sur le principe du moindre privilège;',
          'authentification renforcée et mots de passe robustes;',
          'chiffrement des données en transit et au repos;',
          'sauvegardes régulières et redondantes des données critiques;',
          'surveillance continue et systèmes de prévention des intrusions;',
          'mises à jour régulières des logiciels et correctifs de sécurité;',
          'formation et sensibilisation du personnel en matière de sécurité de l\u2019information.'
        ]
      },
      {
        id: '6.3',
        title: 'Gestion des incidents',
        content: 'Tout incident de sécurité (accès non autorisé, perte de données, fuite d\u2019information) est traité selon un protocole interne rigoureux qui comprend :\n\n- l\u2019identification et le confinement rapide de l\u2019incident;\n- l\u2019évaluation de la portée et de l\u2019impact;\n- la notification aux personnes concernées et, lorsque requis par la loi, à la Commission d\u2019accès à l\u2019information du Québec;\n- la mise en place de mesures correctives pour prévenir la récurrence.'
      },
      {
        id: '6.4',
        title: 'Responsabilité partagée',
        content: 'La sécurité de l\u2019information est une responsabilité partagée. Nous encourageons nos candidats, clients et partenaires à adopter de bonnes pratiques de sécurité, notamment en protégeant leurs identifiants de connexion et en signalant toute activité suspecte à notre équipe.'
      }
    ]
  },
  {
    id: 'communications',
    icon: Mail,
    number: '7',
    title: 'Politique d\u2019envoi des communications',
    subsections: [
      {
        id: '7.1',
        title: 'Types de communications',
        content: 'Dans le cadre de ses activités, Nexor Talents peut vous envoyer les types de communications suivants :',
        list: [
          'opportunités professionnelles correspondant à votre profil;',
          'infolettres contenant des conseils carrière, des articles et des ressources;',
          'communications administratives liées à votre dossier de candidature;',
          'invitations à des événements, webinaires ou contenus professionnels;',
          'mises à jour concernant nos services et nos nouvelles offres.'
        ]
      },
      {
        id: '7.2',
        title: 'Consentement',
        content: 'Nous respectons la Loi canadienne anti-pourriel (LCAP) ainsi que toute législation applicable en matière de communications électroniques. Vos coordonnées ne sont utilisées qu\u2019avec votre consentement explicite ou implicite, conformément à la loi.\n\nChaque communication électronique inclut un mécanisme de désabonnement clair et fonctionnel. Le désabonnement est traité dans un délai maximal de 10 jours ouvrables.'
      },
      {
        id: '7.3',
        title: 'Fréquence',
        content: 'Nous veillons à maintenir une fréquence de communication raisonnable et respectueuse. Vous ne recevrez jamais de sollicitations excessives de notre part.'
      },
      {
        id: '7.4',
        title: 'Sécurité des listes',
        content: 'Les listes de diffusion et les coordonnées de nos abonnés sont protégées par des mesures de sécurité appropriées. Elles ne sont jamais vendues, louées ou partagées à des fins commerciales avec des tiers.'
      }
    ]
  },
  {
    id: 'avis-legal',
    icon: Scale,
    number: '8',
    title: 'Avis légal',
    subsections: [
      {
        id: '8.1',
        title: 'Nature du contenu',
        content: 'Le contenu du site Nexor Talents est fourni à titre informatif et ne constitue en aucun cas un avis juridique, professionnel ou contractuel. Les informations publiées visent à informer les visiteurs sur nos services, nos valeurs et notre expertise.'
      },
      {
        id: '8.2',
        title: 'Exactitude des informations',
        content: 'Bien que nous veillions à l\u2019exactitude et à la mise à jour des informations présentées sur notre site, aucune garantie n\u2019est offerte quant à leur exhaustivité, leur précision ou leur actualité. Nexor Talents se réserve le droit de modifier le contenu du site à tout moment sans préavis.'
      },
      {
        id: '8.3',
        title: 'Limitation de responsabilité',
        content: 'Nexor Talents ne peut être tenue responsable des décisions prises sur la base des informations publiées sur ce site. Toute action entreprise à partir du contenu du site relève de la seule responsabilité de l\u2019utilisateur.'
      },
      {
        id: '8.4',
        title: 'Juridiction',
        content: 'Le présent site et l\u2019ensemble de son contenu sont régis par les lois en vigueur dans la province de Québec, Canada. Tout litige relatif à l\u2019utilisation du site sera soumis aux tribunaux compétents du Québec.'
      }
    ]
  }
];

const PolicySection = ({ policy }) => {
  const [isOpen, setIsOpen] = useState(false);
  const Icon = policy.icon;

  return (
    <div
      data-testid={`policy-section-${policy.id}`}
      className="border-b border-gray-200 last:border-b-0"
    >
      <button
        data-testid={`policy-toggle-${policy.id}`}
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-6 px-6 text-left hover:bg-gray-50 transition-colors group"
      >
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-[#1a1a1a] group-hover:bg-gold transition-colors flex-shrink-0">
            <Icon className="w-5 h-5 text-gold group-hover:text-white transition-colors" />
          </div>
          <div>
            <span className="text-sm font-medium text-gold">{policy.number}.</span>
            <h3 className="text-lg font-semibold text-gray-900 group-hover:text-gold transition-colors">
              {policy.title}
            </h3>
          </div>
        </div>
        <div className="flex-shrink-0 ml-4">
          {isOpen ? (
            <ChevronUp className="w-5 h-5 text-gold" />
          ) : (
            <ChevronDown className="w-5 h-5 text-gray-400 group-hover:text-gold transition-colors" />
          )}
        </div>
      </button>

      {isOpen && (
        <div className="px-6 pb-8 pt-2 ml-16 animate-in fade-in duration-300">
          {policy.subsections.map((sub) => (
            <div key={sub.id} className="mb-6 last:mb-0">
              {sub.title && (
                <h4 className="text-base font-semibold text-[#1a1a1a] mb-2">
                  <span className="text-gold mr-2">{sub.id}</span>
                  {sub.title}
                </h4>
              )}
              {sub.content && (
                <div className="text-gray-600 leading-relaxed text-sm whitespace-pre-line">
                  {sub.content}
                </div>
              )}
              {sub.list && (
                <ul className="mt-2 space-y-1.5">
                  {sub.list.map((item) => (
                    <li key={`${sub.id}-${item.slice(0, 20)}`} className="flex items-start gap-2 text-gray-600 text-sm">
                      <span className="text-gold mt-1.5 flex-shrink-0 w-1.5 h-1.5 rounded-full bg-gold inline-block"></span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
              {sub.afterList && (
                <p className="mt-3 text-gray-600 text-sm font-medium">
                  {sub.afterList}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const PoliciesPage = () => {
  const scrollToSection = (id) => {
    const el = document.querySelector(`[data-testid="policy-section-${id}"]`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const toggle = el.querySelector('button');
      if (toggle) toggle.click();
    }
  };

  return (
    <div className="pt-16" data-testid="policies-page">
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center justify-center bg-gradient-to-br from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a] overflow-hidden">

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-bold text-white mb-6">
            Politiques et informations légales
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
            NEXOR TALENTS — Transparence, conformité et protection
          </p>
        </div>
      </section>

      {/* Table of Contents */}
      <section className="py-12 bg-[#f8f8f6]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-display font-bold text-[#1a1a1a] mb-6 text-center">
            Table des matières
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="toc-grid">
            {policyData.map((policy) => {
              const Icon = policy.icon;
              return (
                <button
                  key={policy.id}
                  data-testid={`toc-link-${policy.id}`}
                  onClick={() => scrollToSection(policy.id)}
                  className="flex items-center gap-3 px-4 py-3 bg-white rounded-lg border border-gray-200 hover:border-gold hover:shadow-sm transition-all text-left group"
                >
                  <Icon className="w-4 h-4 text-gold flex-shrink-0" />
                  <span className="text-sm text-gray-700 group-hover:text-gold transition-colors">
                    <span className="font-semibold">{policy.number}.</span> {policy.title}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Policy Sections */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
            {policyData.map((policy) => (
              <PolicySection key={policy.id} policy={policy} />
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-[#1a1a1a]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl font-display font-bold text-white mb-4">
            Des questions sur nos politiques ?
          </h2>
          <p className="text-gray-300 mb-6">
            Communiquez avec notre responsable de la protection des renseignements personnels.
          </p>
          <a
            href="mailto:cplante@nexortalents.com"
            data-testid="policies-contact-email"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gold hover:bg-[#9a7109] text-white font-semibold rounded-lg transition-colors"
          >
            <Mail className="w-4 h-4" />
            cplante@nexortalents.com
          </a>
        </div>
      </section>
    </div>
  );
};

export default PoliciesPage;
